// 行政管理下面的接口

import request from "@/utils/request";

// 请假申请列表
export function leaveApplicationPage(data) {
  return request({
    url: "/leaveApplication/admin/page",
    method: "post",
    data,
  });
}

// 请假申请导出 /leaveApplication/admin/export
export function leaveApplicationExport(data) {
  return request({
    url: "/leaveApplication/admin/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 用章申请 /stampApplication/admin/page
export function stampApplicationPage(data) {
  return request({
    url: "/stampApplication/admin/page",
    method: "post",
    data,
  });
}

// 用章申请导出
export function stampApplicationExport(data) {
  return request({
    url: "/stampApplication/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 采购申请 /purchaseApplication/admin/page
export function purchaseApplicationPage(data) {
  return request({
    url: "/purchaseApplication/admin/page",
    method: "post",
    data,
  });
}

// 采购申请导出
export function purchaseApplicationExport(data) {
  return request({
    url: "/purchaseApplication/admin/export",
    method: "post",
    params: { ...data },
    responseType: "blob",
  });
}

// 日常消耗借用- 列表 /dailyAssetsLoanApplication/admin/page
export function dailyAssetsLoanApplicationPage(data) {
  return request({
    url: "/dailyAssetsLoanApplication/admin/page",
    method: "post",
    data,
  });
}

// 日常消耗借用- 导出 /dailyAssetsLoanApplication/admin/export
export function dailyAssetsLoanApplicationExport(data) {
  return request({
    url: "/dailyAssetsLoanApplication/admin/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 低值易耗 - 申领列表
export function getDeliveLogList(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getDeliveLogList",
    method: "get",
    params: { ...data },
  });
}

// 低值易耗 - 行政管理 - 导出 /consumableAssetsInfo/backend/getExcelDeliveLogList
export function getDeliveLogListExport(data) {
  return request({
    url: "/consumableAssetsInfo/backend/getExcelDeliveLogList",
    method: "post",
    responseType: "blob",
    params: { ...data },
  });
}
